import { Grid2, Typography } from "@mui/material";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import cn from "classnames";
import { useTranslate } from "../../../hooks/useTranslate";
import Breadcrumbs from "../../../components/Breadcrumbs";
import TaskCard from "../../../components/TaskCard";
import { useStudents } from "../../../context/students";
import Students1 from "../../../assets/images/images/students1.jpg";
import Students2 from "../../../assets/images/images/students2.jpg";
import { useAuth } from "../../../auth";
import { hasPermission, PERMISSIONS } from "../../../constants/permissions";
import LockedPage from "../../../components/LockedPage";
import useStatuses from "../../../context/status/useStatuses";
import { isProduction } from "../../../services/serviceConfig";

const CHOIСES_LINKS = {
    prod: "https://finance.kingsinterhigh.co.uk/annrenpass/",
    dev: "https://devfin.kingsinterhigh.co.uk/annrenpass/",
};
const CHOIСES_LINK = isProduction ? CHOIСES_LINKS.prod : CHOIСES_LINKS.dev;

const Renewals = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();
    const { studentId } = useParams();

    const { userId } = useAuth();
    const { renewalStatus, studentIsamsId } = useStatuses();
    const { activeStudentId, activeStudent, permissions } = useStudents();

    const studentFullName = `${activeStudent.forename} ${activeStudent.surname}`;
    const canFinanceView = hasPermission(permissions, PERMISSIONS.RENEWALS_MANAGE);

    const showConfirmRenewal = renewalStatus?.isRenewalsOpen;
    const showContract = !!renewalStatus?.awaitingPayment && !!renewalStatus?.requiresNewContract;
    const showPayment = !!renewalStatus?.awaitingPayment && !renewalStatus?.requiresNewContract;

    if (!studentId) {
        return (
            <Navigate to="/" replace={true} />
        )
    }

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2} className={cn("mb-8", canFinanceView ? "min-head-section-height--small" : "min-head-section-height")}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("renewals.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("renewals.titlePage", { name: studentFullName })}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("renewals.subtitlePage")}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 9, md: 5, lg: 4 }}>
                    <div className="images-head-section">
                        <div className="img-head-section">
                            <img alt="students-1" src={Students1} />
                        </div>
                        <div className="img-head-section">
                            <img alt="students-2" src={Students2} />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
            <div className="relative z-1">
                <LockedPage showPermissionText isLocked={!canFinanceView}>
                    <Grid2 container spacing={4} className="mt-4">
                        {showConfirmRenewal && (
                            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                                <TaskCard title={t("renewals.movingOnto")}>
                                    <Typography variant="body1" component="div">
                                        {t("renewals.movingOntoSubtitle")}
                                    </Typography>
                                    <Button
                                        className="w-full mt-4 text-base button-primary"
                                        href={`${CHOIСES_LINK}?id=${studentIsamsId}`}
                                        target="_blank"
                                    >
                                        {t("renewals.confirmYourChoices")}
                                    </Button>
                                </TaskCard>
                            </Grid2>
                        )}
                        {showContract && (
                            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                                <TaskCard title={t("renewals.signContractAndPay")}>
                                    <Typography variant="body1" component="div">
                                        {t("renewals.signContractAndPaySubtitle")}
                                    </Typography>
                                    <Button
                                        onClick={() => navigate(`/renewals/contract/${activeStudentId}`)}
                                        className="w-full mt-4 text-base button-accent"
                                    >
                                        {t("renewals.completeNow")}
                                    </Button>
                                </TaskCard>
                            </Grid2>
                        )}
                        {showPayment && (
                            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                                <TaskCard title={t("renewals.payRenewalFee")}>
                                    <Typography variant="body1" component="div">
                                        {t("renewals.payRenewalFeeSubtitle")}
                                    </Typography>
                                    <Button
                                        onClick={() => navigate(`/renewals/payment/${activeStudentId}`)}
                                        className="w-full mt-4 text-base button-accent"
                                    >
                                        {t("renewals.completePayment")}
                                    </Button>
                                </TaskCard>
                            </Grid2>
                        )}
                    </Grid2>
                </LockedPage>
            </div>
        </div>
    );
};

export default Renewals;
